import { render } from "./PagoCliente.vue?vue&type=template&id=06d06804&scoped=true"
import script from "./PagoCliente.vue?vue&type=script&lang=js"
export * from "./PagoCliente.vue?vue&type=script&lang=js"

import "./PagoCliente.vue?vue&type=style&index=0&id=06d06804&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\framacion_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06d06804"]])

export default __exports__